import type { LocaleResources } from '../types';

/**
 * Symbol/Position related UI string resources
 * Used in symbol-list-view, position-list-view, etc.
 */
export const marketStr: LocaleResources['marketStr'] = {
  error: {
    /** Select symbols first before changing leverage */
    selectSymbolsFirst: 'Please select symbols to change leverage first.',
    /** Leverage range error */
    leverageRange: 'Leverage must be between 1 and 100.',
  },
  position: {
    // Buttons and actions
    exitAfterReverse: 'Exit and enter reverse position',
    deleteBackSignal: 'Delete Back Signal',
    exitAll: 'Exit All',
    reverseAll: 'Rev All',
    exit: 'Exit',
    reversePosition: 'Reverse Position',
    // Dropdown menu
    selectedOnly: 'Selected only',
    longOnly: 'Long only',
    shortOnly: 'Short only',
    // Labels
    winCount: 'Winning',
    lossCount: 'Losing',
    investCandidate: 'Candidates:',
    long: 'Long',
    short: 'Short',
    // Summary info
    evalAmount: 'Eval',
    entryAmountTooltip: 'Entry: {amount}',
    longNetProfit: 'Long P&L',
    shortNetProfit: 'Short P&L',
    netProfit: 'Net P&L',
    // Column header sub text
    subTextEntryAmount: '(Entry)',
    subTextEntryPrice: '(Entry)',
  },
  signal: {
    // Buttons and actions
    ignoreThisSignal: 'Ignore this signal',
    enterLong: 'Enter Long',
    enterShort: 'Enter Short',
    enterLongOnly: 'Long Only',
    enterShortOnly: 'Short Only',
    enterAll: 'Enter All',
    ignoreAllSignals: 'Ignore All Signals',
    // Hedge entry
    enterHedge: 'Hedge Entry',
    enterHedgeFailed: 'Hedge entry failed: both Long and Short orders failed.',
    enterHedgePartialFailed: 'Hedge entry partially failed: one direction order failed.',
    enterHedgeConflict: 'Hedge entry blocked: an order line already exists.',
    // Context menu
    enterBySignal: 'Enter by Signal',
  },
  timeframe: {
    search: 'Search',
    rising: 'Rising',
    falling: 'Falling',
  },
  symbolList: {
    // Search
    searchPlaceholder: 'Search symbol...',
    // PillLabel
    undecided: 'Undecided',
    // Select
    leverage: 'Leverage',
    // Buttons
    addInvestCandidate: '+ Candidate',
    removeInvestCandidate: '- Candidate',
    enterLong: 'Enter Long',
    enterShort: 'Enter Short',
    enterLongOnly: 'Long Only',
    enterShortOnly: 'Short Only',
    enterAll: 'Enter All',
    removeAll: 'Remove All',
    // Search options
    trendNone: 'None',
    // Context menu
    enterBySignal: 'Enter by Signal',
    addToInvestList: 'Add to Candidates',
    removeFromInvestList: 'Remove from Candidates',
  },
  searchBox: {
    // Select placeholder
    selectPreset: 'Select Preset',
    // Buttons
    search: 'Search',
    save: 'Save',
    delete: 'Delete',
    close: 'Close',
    addCondition: '+ Condition',
    // Input placeholders
    presetName: 'Preset Name',
    note: 'Note',
    searchPlaceholder: 'Search',
    // Titles
    addConditionTitle: 'Add Condition',
    deleteConditionTitle: 'Delete Condition',
    // Error messages
    enterPresetName: 'Please enter a preset name.',
  },
  correlation: {
    // Button and labels
    calculateButton: 'Calculate Correlation',
    calculating: 'Calculating correlation. Please wait...',
    cancelButton: 'Stop',
    // Modal
    modalTitle: '{timeframe} Candle Correlation Calculation',
    baseAsset: 'Base Asset',
    baseAssetHelp: 'Compare with {count} selected symbols',
    baseAssetPlaceholder: 'Select base asset from all symbols',
    baseAssetRequired: 'Please select a base asset.',
    priceType: 'Price Type',
    priceTypeRequired: 'Please select a price type.',
    priceTypeOpenClose: 'Open - Close',
    priceTypeLowHigh: 'Low - High',
    valueType: 'Value Type',
    valueTypeRequired: 'Please select a value type.',
    valueTypePrice: 'Price',
    valueTypePercentage: 'Price Change %',
    calculationPeriodStart: 'Calculation Period (Start)',
    calculationPeriodEnd: 'Calculation Period (End)',
    startTimeRequired: 'Please select start time.',
    endTimeRequired: 'Please select end time.',
    candleCount: 'Correlation Candle Count',
    candleCountHelp: 'Automatically calculated based on {timeframe} candles.',
    candleCountHelpWithLimit: 'Automatically calculated based on {timeframe} candles. (Max {limit})',
    candleCountHelpNoTimeframe: 'No candle timeframe selected.',
    candleCountUnit: '',
    calculateAction: 'Calculate',
    cancelAction: 'Cancel',
    // Tooltip
    tooltipPriceType: 'Price Type',
    tooltipValueType: 'Value Type',
    tooltipPeriod: 'Period',
    tooltipLastCalculated: 'Last Calculated',
    // Messages
    selectAtLeastOne: 'Please select at least 1 symbol.',
    endTimeMustBeAfterStart: 'End time must be after start time.',
    candleCountExceeded: 'Candle count exceeded maximum ({limit}). Period adjusted automatically.',
    calculationComplete: 'Correlation calculation complete: {count} symbols ({seconds}s)',
    calculationCanceled: 'Correlation calculation canceled.',
    loadingExchangeConfig: 'Loading exchange config. Please try again later.',
  },
  modal: {
    selectSymbol: 'Select Symbol',
  },
};
